var _excluded = ["arrowSize", "children", "color", "underline"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
import { ChevronRight } from "../../icons/index.js";
import Icon from "../basic/Icon/Icon.js";
var StyledIcon = styled(Icon).withConfig({
  componentId: "CL__sc-z3yi7n-0"
})(["vertical-align:middle;transform:translate(-18%,-1px);"]);
var StyledLink = styled.a.withConfig({
  componentId: "CL__sc-z3yi7n-1"
})(["color:", ";font-weight:600;text-decoration:", " !important;cursor:pointer;&:link,&:visited{font-weight:600;color:var(--link-color);text-decoration:underline;}&:hover{font-weight:600;color:var(--link-color-hover);}&:active{font-weight:600;color:var(--link-color-active);}"], _ref => {
  var {
    color
  } = _ref;
  return color;
}, _ref2 => {
  var {
    underline
  } = _ref2;
  return underline ? 'underline' : 'none';
});
var LinkText = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  var {
      arrowSize,
      children,
      color = 'var(--link-color)',
      underline = true
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    color: color,
    ref: ref,
    underline: underline
  }, props), children, arrowSize && /*#__PURE__*/React.createElement(StyledIcon, {
    color: color,
    component: ChevronRight,
    size: arrowSize
  }));
});
export default LinkText;